export default function extractReportReceptableProject(projectList) {
  let filteredProjects = []
  projectList.map(project => {
    if (project.custom_fields[1].value === '1') {
      filteredProjects.push(project)
    }
  })
  return filteredProjects
}
